import Player from "@vimeo/player";
import { gsap } from "gsap";

export default function videoPlayEvents() {
    let videos = document.querySelectorAll(".article__body__block__video__media");
    videos.forEach(video => {
        video.addEventListener("play", function () {
            this.parentElement.classList.add("playing");
        });

        video.addEventListener("pause", function () {
            this.parentElement.classList.remove("playing");
        });
    });

    let iframeVideos = document.getElementsByClassName("scr-panel__sticky__img--frame");
    if (iframeVideos.length > 0) {
        for (let i = 0; i < iframeVideos.length; i++) {
            if (iframeVideos[i].id.length > 0) {
                let options = {
                    id: iframeVideos[i].id.replace("mobilevar-", ""),
                    autoplay: false,
                    muted: true,
                    controls: (iframeVideos[i].dataset.controls === "1" ? true : false),
                    title: false,
                    loop: true,
                    width: 100,
                    height: 100
                };

                const player = new Player(iframeVideos[i].id, options);

                player.enableTextTrack("en").then(function (track) {
                    player.getTextTracks().then(function (tracks) {
                        tracks.forEach(track => {
                            track.mode = "enabled";
                        });
                    });

                }).catch(function (error) {
                    player.enableTextTrack("en-x-autogen").then(function (track) {
                        player.getTextTracks().then(function (tracks) {
                            tracks.forEach(track => {
                                track.mode = "enabled";
                            });
                        });
                    });
                });

                gsap.to(iframeVideos[i], {
                    scrollTrigger: {
                        trigger: iframeVideos[i],
                        start: "top bottom",
                        end: "bottom top",
                        onEnter: () => player.play(),
                        onEnterBack: () => player.play(),
                        onLeave: () => player.pause(),
                        onLeaveBack: () => player.pause(),
                    }
                })
            }
        }
    }
}